export const Arrow = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="#fff"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.17949 10.2887L20 0.57735L36.8205 10.2887V29.7113L20 39.4226L3.17949 29.7113V10.2887Z"
      stroke="#9F6B08"
    />
    <path
      d="M20.3536 12.9798C20.1583 12.7845 19.8417 12.7845 19.6464 12.9798L16.4645 16.1618C16.2692 16.357 16.2692 16.6736 16.4645 16.8689C16.6597 17.0641 16.9763 17.0641 17.1716 16.8689L20 14.0404L22.8284 16.8689C23.0237 17.0641 23.3403 17.0641 23.5355 16.8689C23.7308 16.6736 23.7308 16.357 23.5355 16.1618L20.3536 12.9798ZM20.5 26.6667L20.5 13.3333H19.5L19.5 26.6667H20.5Z"
      fill="#9F6B08"
    />
  </svg>
);
